import React, { useEffect } from 'react';
import { useForm } from "react-hook-form";
import MUIModal from '../../common/MUIModal';
import { Alert, Box, Grid, Typography } from "@mui/material";
import { FormProvider, RHFDateField, RHFFileField, RHFTextField } from "../../common/hook-form";
// import * as Yup from "yup";
// import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from '@mui/lab';
import { apiConstants, postGeneric } from '../../common/constants';
// import { subDays } from 'date-fns';

const NdrAction = (props) => {
    const { show, handleClose, currentNDRId, isLoadingBtn } = props;

    function convertDate(inputFormat) {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        var d = new Date(inputFormat)
        return [pad(d.getFullYear()), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
    }

    const onSubmit = async (data) => {
        let voc_remark = null;
        if (data.file && data.file.length > 0) {
            const formData = new FormData();
            formData.append('file', data.file[0]);
            formData.append('folderName', 'ndrVOC');
            try {
                const response = await postGeneric(apiConstants.UPLOAD_REMARK, formData);
                if (response.status === 200) {
                    voc_remark = {
                        file_url: response.data.file_url,
                        folder_name: 'ndrVOC',
                    }
                }
            } catch (error) {
                console.log(error);
                data.fileUploadError = error.message || 'File upload failed';
            }
        }
        data.preferred_date = convertDate(data.preferred_date)
        delete data.file;
        const payload = { ...data, voc_remark };
        props.handleReattemp(payload);
    };

    // const phoneRegExp = /^\d{10}$/;
    const methods = useForm({
        defaultValues: {
            file: null,
        }
        // resolver: yupResolver(
        //     Yup.object().shape({
        //         address: Yup.string().required("Address is required!"),
        //         landmark: Yup.string().required("Landmark is required!"),
        //         phone_number: Yup.string()
        //             .matches(phoneRegExp, { message: 'Phone Number must be exactly 10 digits', excludeEmptyString: true })
        //             .min(10, 'Phone Number must be at least 10 digits')
        //             .required("Phone Number is required!"),
        //         drop_pincode: Yup.number().typeError('Pincode must be valid').positive().typeError('Pincode must be valid').required("Pincode is required!"),
        //         preferred_date: Yup.date()
        //             .typeError('Reattempt date is required')
        //             .required('Reattempt date is required')
        //             .min(subDays(new Date(), 1), 'Reattempt date cannot be in the past', { inclusive: true }),
        //     })
        // ),

    })
    const { handleSubmit: handleSubmitForm, reset } = methods

    const hideModal = () => {
        handleClose();
    };

    useEffect(() => {
        if (currentNDRId && currentNDRId.delivery_details) {
            let defaultValues = {
                phone_number: currentNDRId.delivery_details.to_phone_number,
                drop_pincode: currentNDRId.delivery_details.to_pincode,
                address: currentNDRId.delivery_details.to_address,
                preferred_date: new Date(),
                file: null,
            };
            reset({ ...defaultValues });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentNDRId]);


    return (
        <MUIModal open={show} handleClose={hideModal} title={`Reattempt Action / ${currentNDRId.awb_number}`}>
            <Grid container spacing={5}>
                <Grid item xs={12}>
                    <FormProvider
                        methods={methods}
                        onSubmit={handleSubmitForm(onSubmit)}
                        className="w-100"
                    >
                        <Grid container spacing={2}>
                            {/* <Grid item xs={6}>
                                <RHFTextField disabled name="awb" mandatory="true" label="AWB" variant="filled" />
                            </Grid> */}
                            <Grid item xs={12}>
                                <RHFTextField multiline name="address" label="Address" variant="filled" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="landmark" label="Landmark" variant="filled" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="drop_pincode" label="Pincode" variant="filled" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="phone_number" label="Phone Number" variant="filled" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFDateField name="preferred_date" disablePast label="Delivery Request Date" variant="filled" />
                            </Grid>
                            <Grid item xs={6}>
                                <RHFTextField name="remark" label="Remark" variant="filled" />
                                <Box sx={{ mt: 1 }}>
                                    <Typography variant='body2' color='error'>* Remark is for internal use and will not be sent to courier</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={6}>
                                <RHFFileField name="file" label=" Add Buyer VOC" variant="filled" size={2} />
                            </Grid>
                            <Grid item xs={12} md={12} sx={{ mt: 2 }}>
                                <LoadingButton
                                    loading={isLoadingBtn}
                                    // fullWidth
                                    type="submit"
                                    variant="contained"
                                    size="small"
                                >
                                    Submit
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Grid>
            </Grid>

        </MUIModal>
    );
};
export default NdrAction;



